import {
    RocketOutlined,
    CalendarOutlined,
    BankOutlined,
    TrophyOutlined,
    TeamOutlined,
    UserAddOutlined,
    StopOutlined,
    FileSearchOutlined
} from '@ant-design/icons-vue';
import MembersList from '@/views/members/MemberList.vue';
import { MEMBER_LIST_PROFILE } from '@/views/members/memberListProfiles.js';

export const partnerOpsFolderRoute = {
    path: 'partner-ops',
    name: 'PartnerOps',
    redirect: '/members/business',
    meta: {
        title: '夥伴營運',
        icon: RocketOutlined
    },
    children: []
};

export const partnerOpsChildrenRoutes = [
    {
        path: '/members/business',
        component: MembersList,
        name: 'MembersBusiness',
        meta: {
            title: '會員管理',
            icon: TeamOutlined,
            memberListProfile: MEMBER_LIST_PROFILE.BUSINESS
        }
    },
    {
        path: 'attendance',
        component: () => import('@/views/members/PartnerAttendance.vue'),
        name: 'PartnerOpsAttendance',
        meta: {
            title: '出席管理',
            icon: CalendarOutlined
        }
    },
    {
        path: 'legacy-students',
        component: () => import('@/views/partnerOps/LegacyStudentPrecreates.vue'),
        name: 'PartnerOpsLegacyStudents',
        meta: {
            title: '舊生預建／認領',
            icon: UserAddOutlined
        }
    },
    {
        path: 'access-blocklist',
        component: () => import('@/views/partnerOps/AccessBlocklist.vue'),
        name: 'PartnerOpsAccessBlocklist',
        meta: {
            title: '識別黑名單',
            icon: StopOutlined
        }
    },
    {
        path: 'course-intake',
        component: () => import('@/views/partnerOps/CourseIntakeReport.vue'),
        name: 'PartnerOpsCourseIntake',
        meta: {
            title: '課程進件查詢',
            icon: FileSearchOutlined
        }
    },
    {
        path: 'departments',
        component: () => import('@/views/settings/Departments.vue'),
        name: 'Departments',
        meta: {
            title: '事業部清單',
            icon: BankOutlined
        }
    },
    {
        path: 'ranks',
        component: () => import('@/views/settings/Ranks.vue'),
        name: 'Ranks',
        meta: {
            title: '聘階管理',
            icon: TrophyOutlined
        }
    }
];

/** 舊路徑：不影響既有書籤，側欄不顯示 */
export const partnerOpsLegacyRoutes = [
    {
        path: '/members/attendance',
        redirect: '/partner-ops/attendance',
        meta: { hidden: true }
    },
    {
        path: '/platform/departments',
        redirect: '/partner-ops/departments',
        meta: { hidden: true }
    },
    {
        path: '/platform/ranks',
        redirect: '/partner-ops/ranks',
        meta: { hidden: true }
    },
    {
        path: '/departments',
        redirect: '/partner-ops/departments',
        meta: { hidden: true }
    },
    {
        path: '/ranks',
        redirect: '/partner-ops/ranks',
        meta: { hidden: true }
    },
    {
        path: '/levels/level-config-management',
        redirect: '/levels/level-setting',
        meta: { hidden: true }
    }
];
